import { capitalize } from '@material-ui/core/utils'
import Cookies from 'js-cookie'

export const COOKIE_KEYS = {
  KLAVIYO_EMAIL_FORM_SUBMITTED: 'klaviyoEmailFormSubmitted',
  KLAVIYO_PHONE_NUMBER_FORM_SUBMITTED: 'klaviyoPhoneNumberFormSubmitted',
}

export const KLAVIYO_FORM_TYPES = {
  EMBED: 'embed',
  POPUP: 'popup',
}

const SUBMITTED_FORM_TYPES = [KLAVIYO_FORM_TYPES.POPUP, KLAVIYO_FORM_TYPES.EMBED]

export const getKlaviyoArtkiveProperties = () => {
  if (typeof window !== 'undefined' && window.app.klaviyo) {
    return window.app.klaviyo
  }
}

export const klaviyoFormClass = 'klaviyo-form'

// TODO For follow-up task after Escalating Email Grabber
// SMS ONLY FORM
// export const KLAVIYO_MOBILE_POPUP_SMS_ONLY_FORM_ID = ''
// export const KLAVIYO_DESKTOP_POPUP_SMS_ONLY_FORM_ID = 'YjM4jm'
// export const PROMO_SMS_ONLY = 'HANDPRINTTURKEY'

const handleIdentifyUser = (form) => {
  const emailInput = form.querySelector('input[name="email"]')
  if (!emailInput) return

  const phone = form.querySelector('input[name="phone-number"]')?.value
  let firstName = form.querySelector('input[autocomplete="given-name"]')?.value
  firstName = firstName && capitalize(firstName)
  let lastName = form.querySelector('input[autocomplete="family-name"]')?.value
  lastName = lastName && capitalize(lastName)
  const name = [firstName, lastName].filter(Boolean).join(' ')

  window.customIdentify({ email: emailInput.value, name, firstName, lastName, phone })
}

const getFormType = (formId) => {
  const klaviyoEmbedFormIds = [
    getKlaviyoArtkiveProperties()?.klaviyoEmbedEmailFormId,
    getKlaviyoArtkiveProperties()?.klaviyoEmbedPhoneFormId,
  ]
  const isEmbedForm = klaviyoEmbedFormIds.includes(formId)
  return isEmbedForm ? KLAVIYO_FORM_TYPES.EMBED : KLAVIYO_FORM_TYPES.POPUP
}

export const handleKlaviyoFormSubmit = (onSubmitEmail, onSubmitPhoneNumber) => (event) => {
  const button = event.target
  if (button.tagName !== 'BUTTON' || !button.classList.contains('needsclick')) return

  const form = button.closest('form')
  if (!form || !form.classList.contains(klaviyoFormClass)) return

  handleIdentifyUser(form)

  const formId = form.getAttribute('data-testid').split(`${klaviyoFormClass}-`)[1]

  const emailFormButtonTextContent = getKlaviyoArtkiveProperties()?.emailFormButtonTextContent
  if (button.textContent === emailFormButtonTextContent) {
    const emailInput = form.querySelector('input[name="email"]')
    const firstName = form.querySelector('input[autocomplete="given-name"]')?.value

    if (!emailInput) return

    const formType = getFormType(formId)
    onSubmitEmail({ formId, formType, firstName, email: emailInput.value })
    const expires = getKlaviyoArtkiveProperties()?.klaviyoFormResetInDays
    Cookies.set(COOKIE_KEYS.KLAVIYO_EMAIL_FORM_SUBMITTED, formType, { expires })
  }

  const phoneNumberFormButtonTextContent = getKlaviyoArtkiveProperties()?.phoneNumberFormButtonTextContent
  if (button.textContent === phoneNumberFormButtonTextContent) {
    const phoneInput = form.querySelector('input[autocomplete="tel"]')
    if (!phoneInput) return

    const formType = getFormType(formId)
    onSubmitPhoneNumber({ formId, formType, phoneNumber: phoneInput.value })
    const expires = getKlaviyoArtkiveProperties()?.klaviyoFormResetInDays
    Cookies.set(COOKIE_KEYS.KLAVIYO_PHONE_NUMBER_FORM_SUBMITTED, formType, { expires })
  }
}

export const getEmbedFormIdToDisplay = () => {
  const isEmailFormSubmitted = Cookies.get(COOKIE_KEYS.KLAVIYO_EMAIL_FORM_SUBMITTED)
  const isPhoneNumberFormSubmitted = Cookies.get(COOKIE_KEYS.KLAVIYO_PHONE_NUMBER_FORM_SUBMITTED)
  const embedEmailFormId = getKlaviyoArtkiveProperties()?.klaviyoEmbedEmailFormId
  const embedPhoneFormId = getKlaviyoArtkiveProperties()?.klaviyoEmbedPhoneFormId

  if (SUBMITTED_FORM_TYPES.includes(isPhoneNumberFormSubmitted)) return ''
  if (SUBMITTED_FORM_TYPES.includes(isEmailFormSubmitted)) return embedPhoneFormId
  return embedEmailFormId
}

export const isPopupFormSubmitted = () => {
  const isEmailFormSubmitted = Cookies.get(COOKIE_KEYS.KLAVIYO_EMAIL_FORM_SUBMITTED)
  const isPhoneNumberFormSubmitted = Cookies.get(COOKIE_KEYS.KLAVIYO_PHONE_NUMBER_FORM_SUBMITTED)

  return isEmailFormSubmitted === KLAVIYO_FORM_TYPES.POPUP && isPhoneNumberFormSubmitted === KLAVIYO_FORM_TYPES.POPUP
}

export const isEmailStepSubmitted = () => {
  const isEmailFormSubmitted = Cookies.get(COOKIE_KEYS.KLAVIYO_EMAIL_FORM_SUBMITTED)
  return SUBMITTED_FORM_TYPES.some((type) => type === isEmailFormSubmitted)
}

export const isPhoneStepSubmitted = () => {
  const isPhoneNumberFormSubmitted = Cookies.get(COOKIE_KEYS.KLAVIYO_PHONE_NUMBER_FORM_SUBMITTED)
  return SUBMITTED_FORM_TYPES.some((type) => type === isPhoneNumberFormSubmitted)
}
